//Custo css import
import './style.css'

//Widgets import
import { AiOutlineDollar } from 'react-icons/ai'; // Using AiOutlineDollar for spends icon
import ModalBtn from '../../molecules/modalButton/view';

import SpendTypeTable from '../SpendTypeTable/view';

function Spends() {

    return (
        <ModalBtn
            id="spendsPlan"
            className='btn-acc-rep-modal'
            icon={<AiOutlineDollar></AiOutlineDollar>}
            title="Gastos"
        >
            <SpendTypeTable></SpendTypeTable>
        </ModalBtn>
    )
}

export default Spends
